import { useState } from "react";
import CreatableSelect, { CreatableProps } from "react-select/creatable";
import { getSelectStyles } from "./select-styling";
import { FieldSkeleton } from "./FieldSkeleton";

type Props = {
  innerRef?: any;
  errorMessage?: string;
  label?: string;
  helperText?: string;
  width?: string;
  createOption: (inputValue: string) => Promise<any>;
  value: string | number | string[] | number[] | undefined;
  options: { value: string | number; label: string }[];
} & CreatableProps<any, any, any>;

export const CreateableSelectField = ({
  isMulti,
  errorMessage,
  createOption,
  value,
  innerRef,
  label,
  helperText,
  width,
  options,
  ...rest
}: Props) => {
  const [isLoading, setIsLoading] = useState(false);

  const getValue = () => {
    if (Array.isArray(value)) {
      return options.filter((option) => value.includes(option.value));
    }
    return options.find((option) => option.value === value);
  };

  const handleCreate = async (inputValue: string) => {
    setIsLoading(true);
    await createOption(inputValue);
    setIsLoading(false);
  };

  return (
    <FieldSkeleton
      errorMessage={errorMessage}
      helperText={helperText}
      label={label}
      width={width}
    >
      <CreatableSelect
        isDisabled={isLoading}
        styles={getSelectStyles({ isMulti, errorMessage })}
        isLoading={isLoading}
        onCreateOption={handleCreate}
        options={options}
        value={getValue()}
        isMulti={isMulti}
        ref={innerRef}
        {...rest}
      />
    </FieldSkeleton>
  );
};
